<template>
  <b-container>
    <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items"/>

    <b-table small outlined striped hover :items="form_items" :fields="form_fields">
      <template v-slot:cell(index)="data">
        {{data.index+1}}
      </template>

      <template v-slot:cell(username)="data">
        <b-form-input type="text" required placeholder v-model="data.item.username"></b-form-input>
      </template>

      <template v-slot:cell(name)="data">
        <b-form-input type="text" required placeholder v-model="data.item.name"></b-form-input>
      </template>

      <template v-slot:cell(phone)="data">
        <b-form-input type="text" required placeholder v-model="data.item.phone"></b-form-input>
      </template>
    </b-table>

    <b-button type="button" variant="primary" @click="addFormRow()">Add Row</b-button>

    <b-button class="float-right" type="submit" variant="primary" @click="submitForm()">Submit</b-button>
  </b-container>
</template>

<script>
export default {
  name: "DriverEdit",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  data() {
    return {
      breadcrumb_items: [
        {
          text: "Drivers",
          to: { name: "drivers" }
        },
        {
          text: "Manage Drivers",
          active: true
        }
      ],

      form_fields: [
        {
          key: "index",
          label: "#"
        },
        {
          key: "username",
          label: "Username"
        },
        {
          key: "name",
          label: "Driver Name"
        },
        {
          key: "phone",
          label: "Phone"
        }
      ],
      form_items: [
      ]
    };
  },

  async created() {
    await this.getDrivers();
    this.addFormRow();
  },
  methods : {
    addFormRow (){
      this.form_items.push({
          username : '',
          name : '',
          phone: ''
        });
    },
    submitForm(){
      this.addDrivers();
    },

    async getDrivers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "driver_get.php",
        data: {
          limit: 99999,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.form_items = response.data.drivers;
    },

    async addDrivers() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "driver_bulk.php",
        data: {
          drivers : this.form_items
        }
      });

      if (response.data.status == "success") {
        this.$router.go(-1);
      } else {
        alert("something goes wrong...");
      }
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/DriverManage.vue